import api from './api';

export const taskService = {
  async getTasks(projectId, params = {}) {
    const response = await api.get(`/tasks/project/${projectId}`, { params });
    return response.data;
  },
  
  async getTask(taskId) {
    const response = await api.get(`/tasks/${taskId}`);
    return response.data.data;
  },
  
  async createTask(projectId, data) {
    const response = await api.post(`/tasks/project/${projectId}`, data);
    return response.data.data;
  },
  
  async updateTask(taskId, data) {
    const response = await api.patch(`/tasks/${taskId}`, data);
    return response.data.data;
  },
  
  async deleteTask(taskId) {
    const response = await api.delete(`/tasks/${taskId}`);
    return response.data;
  },
  
  async getMyTasks(params = {}) {
    const response = await api.get('/tasks/my-tasks', { params });
    return response.data;
  },
  
  async getCalendarTasks(params) {
    const response = await api.get('/tasks/calendar', { params });
    return response.data.data;
  },
  
  async addTimeEntry(taskId, data) {
    const response = await api.post(`/tasks/${taskId}/time-entries`, data);
    return response.data.data;
  },
  
  async updateTimeEntry(taskId, entryId, data) {
    const response = await api.patch(`/tasks/${taskId}/time-entries/${entryId}`, data);
    return response.data.data;
  },
  
  async deleteTimeEntry(taskId, entryId) {
    const response = await api.delete(`/tasks/${taskId}/time-entries/${entryId}`);
    return response.data;
  },
  
  async addComment(taskId, content) {
    const response = await api.post(`/tasks/${taskId}/comments`, { content });
    return response.data.data;
  },
  
  async deleteComment(taskId, commentId) {
    const response = await api.delete(`/tasks/${taskId}/comments/${commentId}`);
    return response.data;
  },
  
  async updateChecklist(taskId, checklist) {
    const response = await api.put(`/tasks/${taskId}/checklist`, { checklist });
    return response.data.data;
  },
  
  async toggleChecklistItem(taskId, itemId) {
    const response = await api.patch(`/tasks/${taskId}/checklist/${itemId}/toggle`);
    return response.data.data;
  }
};
